import { getQueryClient } from '@/plugins/vue-query'

export const useQueryClientService = () => {
	const queryClient = getQueryClient()

	const invalidateQueries = (queryKey: readonly unknown[]) => {
		void queryClient.invalidateQueries({ queryKey })
	}

	const fetchQuery = async <TData>(
		config: () => {
			queryKey: readonly [string, string, { query: any }]
			queryFn: () => Promise<TData>
		},
	): Promise<TData> => {
		const query = config()

		return await queryClient.fetchQuery(query)
	}

	return {
		queryClient,
		fetchQuery,
		invalidateQueries,
	}
}
